import ListView from "./ListView/ListView";
import DetailView from "./DetailView";

const HistoryChemist = () => <p>History Chemist</p>;

HistoryChemist.ListView = ListView;
HistoryChemist.DetailView = DetailView;
export default HistoryChemist;
